import React, { lazy, Suspense } from 'react';
import Loader from '../Common/Loader/Loader.jsx';

const TestAccountsPage = lazy(() => import('./TestAccountsPage.jsx'));

const LazyTestAccountsPage = () => (
  <Suspense fallback={<Loader />}>
    <TestAccountsPage />
  </Suspense>
);

export default LazyTestAccountsPage;
